/* eslint-disable react/jsx-filename-extension */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'utils/classnames';
import Rating from 'components/base/rating/Rating';
import useAppendQueryParams from 'hooks/custom/useAppendQueryParams';
import { QUERY_PARAMS } from 'consts';
import ResultCardContext from './ResultCardContext';
import ResultCardInfoRow from './ResultCardInfoRow';
import ResultCardLogo from './ResultCardLogo';
import ResultCardLink from './ResultCardLink';
import ResultCardTitle from './ResultCardTitle';

const { IMPRESSION_GUID_PARAM } = QUERY_PARAMS;

function ResultCardBody({
  id,
  isLoading,
  isMobile,
  isProgramView,
  highlights,
  logoImg,
  name,
  onCTAclick,
  onTitleClick,
  cardLink,
  onLogoClick,
  rating,
  impressionGuid,
}) {
  const { ratingTooltipText } = useContext(ResultCardContext);
  const _highlights = highlights && (Array.isArray(highlights) ? highlights.join('') : highlights);
  const learnMoreLink = useAppendQueryParams(cardLink, {
    [IMPRESSION_GUID_PARAM]: impressionGuid,
    click_location: isProgramView
      ? 'best matching card | learn-more'
      : 'school card | learn-more',
  });

  return (
    <div className="resultCard__info">
      <div
        className={cx('resultCard__schoolInfo', {
          resultCard__logoSection: !isMobile,
        })}
      >
        {!isMobile && (
          <div className="resultCard__schoolLogo">
            <ResultCardLogo
              isLoading={isLoading}
              linkUrl={cardLink}
              logoImg={logoImg}
              onClick={onLogoClick}
              impressionGuid={impressionGuid}
              isProgramView={isProgramView}
            />
          </div>
        )}
        {isMobile && (
          <ResultCardInfoRow
            isLoading={isLoading}
            label="Editor's Rating"
            toolTip={{
              label: 'More Info',
              text: ratingTooltipText,
            }}
            value={isLoading ? '' : <Rating rating={rating} id={id} />}
            className="hasRating"
          />
        )}
        <ResultCardLink
          linkUrl={learnMoreLink}
          target="_blank"
          rel="noreferrer"
          className="resultCard__cta"
          onClick={onCTAclick}
        >
          {isProgramView ? 'Visit Site' : 'Find Your Program'}
        </ResultCardLink>
        {isMobile && _highlights && (
          <ResultCardInfoRow
            isLoading={isLoading}
            label="School Highlights"
            value={_highlights}
            className="hasHighlights"
          />
        )}
      </div>

      <div className="resultCard__details">
        {!isMobile && (
          <ResultCardTitle
            className="resultCard__title"
            impressionGuid={impressionGuid}
            isProgramView={isProgramView}
            linkUrl={cardLink}
            onClick={onTitleClick}
          >
            {name}
          </ResultCardTitle>
        )}
        <div className="resultCard__meta">
          {!isMobile && (
            <ResultCardInfoRow
              isLoading={isLoading}
              className="hasRating"
              label="Editor's Rating"
              toolTip={{
                label: 'More Info',
                text: ratingTooltipText,
              }}
              value={isLoading ? '' : <Rating rating={rating} id={id} />}
            />
          )}

          {!isMobile && (
            <ResultCardInfoRow
              isLoading={isLoading}
              label="School Highlights"
              value={_highlights}
              className="hasHighlights"
            />
          )}
        </div>
      </div>
    </div>
  );
}

ResultCardBody.propTypes = {
  cardLink: PropTypes.node,
  description: PropTypes.string,
  highlights: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string,
  impressionGuid: PropTypes.string,
  isLoading: PropTypes.bool,
  isMobile: PropTypes.bool,
  isProgramView: PropTypes.bool,
  learningType: PropTypes.string,
  logoUrl: PropTypes.string,
  name: PropTypes.string,
  onCTAclick: PropTypes.func,
  onLogoClick: PropTypes.func,
  onTitleClick: PropTypes.func,
  rating: PropTypes.number,
};

export default ResultCardBody;
